export default "__VITE_ASSET__Cy_VBH_7__"